// extracted by mini-css-extract-plugin
module.exports =  {"list":"xk3_zEI","icon-container":"YvimenB","iconContainer":"YvimenB","subcategory-label":"G0Wu2J3","subcategoryLabel":"G0Wu2J3","title":"SpN2lCc","item":"wJCJACQ"};